import { render } from "./UserForMicrophoneItem.vue?vue&type=template&id=23a57ac8&scoped=true"
import script from "./UserForMicrophoneItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserForMicrophoneItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./UserForMicrophoneItem.vue?vue&type=style&index=0&id=23a57ac8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a57ac8"]])

export default __exports__